export const LANG_EN = {
  drafts_title: "Recently edited",
  new_article: "New Article",
  new_folder: "New Folder",
  folder_name: "Folder name",
  article_name: "Article name",
  empty_snippet: "Start collect insigths though faktual's chrome extension",
  custom_snippet_placeholder: "Tap here to add a new block...",
  editor_placeholder: "Let's write an awesome story!",
  search_placeholder: "Type to search",
  simple_search_placeholder: "Search",
  own_archive: "Own archives",
  paid_databases: "Paid databases",
  database_label: "Your archives and databases",
  database_subtitle: "Connect your silos",
  user_header: "Personal Settings",
  update_button: "Update",
  cancel: "Cancel",
  password: "Password",
  first_name: "First Name",
  surname: "Last Name",
  database_state: "On request",
  new_stories_title: "Your feed",
  date: "Date",
  date_placeholder: "From - to",
  region_placeholder: "In which region are you looking",
  category_placeholder: "What kind of source are you looking for?",
  source: "Source",
  sources: "Sources",
  source_type: "Type",
  region: "Region",
  add: "Add",
  description: "Description",
  coming_soon: "Coming soon",
  media: "Media",
  statistics: "Statistics",
  feedback: "Give Feedback",
  logout: "Logout",
};

export const LANG_DE = {
  drafts_title: "Zuletzt bearbeitet",
  new_article: "Neuer Artikel",
  new_folder: "Neuer Ordner",
  article_name: "Artikelname",
  folder_name: "Ordnername",
  empty_snippet: "Ziehen Sie Textfelder hierher oder klicken Sie auf Speichern",
  custom_snippet_placeholder:
    "Tippen Sie hier, um einen neuen Block hinzuzufügen...",
  editor_placeholder: "Lass uns eine tolle Geschichte schreiben!",
  search_placeholder: "Zum Suchen tippen",
  simple_search_placeholder: "Suche",
  own_archive: "Eigene Archive",
  paid_databases: "Bezahlte Datenbanken",
  database_label: "Ihre Archive und Datenbanken",
  database_subtitle: "Verbinden Sie Ihre Silos",
  user_header: "Persönliche Einstellungen",
  update_button: "Ändern",
  cancel: "Abbruch",
  password: "Passwort",
  first_name: "Vorname",
  surname: "Nachname",
  database_state: "Coming soon",
  new_stories_title: "Neuste Stories",
  date: "Datum",
  date_placeholder: "Von - Bis",
  region_placeholder: "In welcher Regio suchen Sie",
  category_placeholder: "Nach welcher Art Quelle suchen Sie?",
  source: "Quelle",
  sources: "Quellen",
  source_type: "Quellyp",
  region: "Region",
  add: "Hinzufügen",
  description: "Beschreibung",
  coming_soon: "Coming soon",
  media: "Medienseite",
  statistics: "Encyclopedia",
  feedback: "Feedback geben",
  logout: "Abmelden",
};
